/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const e=["web-gltf","web","cim"];export{e as defaultAcceptedFormats};
